import { floor } from "lodash";

export const minCommission = 0.05;

export const commissionFromSalePrice = (saleTotal) => {
  let commission = floor(saleTotal * 0.08, 2);

  return Math.max(commission, minCommission);
};
